import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  HeadingDisplay,
  HelperViewStatus,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';

import { AssetRow } from './components/AssetRow';
import { PortabilityDetailsLoader } from './components/PortabilityDetailsLoader';

import {
  getPortabilityDetails,
  PortabilityDetails,
  PortabilityRequestConclusionResponse,
  PortabilityRequestStatus,
  updatePortabilityRequest
} from '@/modules/trade/services/portability';
import { PortabilityRequestSteps } from '../../types';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { notify } from '@/modules/common/helpers/notification';
import { isImpersonate } from '@/modules/common/services/partner';
import { MFAModules } from '@/modules/authentication/views/SecurityView/components/MultiFactorAuthentication';

interface Emit {
  (e: 'on-change-step', step: PortabilityRequestSteps): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityInformation',
  emits: ["on-change-step"],
  setup(__props, { emit }: { emit: ({
  (e: 'on-change-step', step: PortabilityRequestSteps): void;
}), expose: any, slots: any, attrs: any }) {

const isLoading = ref(true);
const hasError = ref(false);
const isAcceptingPortability = ref(false);
const isRejectingPortability = ref(false);

const portability = inject(
  'portabilityRequest'
) as Ref<PortabilityDetails | null>;
const portabilityRequestConclusion = inject(
  'portabilityRequestConclusion'
) as Ref<PortabilityRequestConclusionResponse | null>;



const route = useRoute();
const router = useRouter();

const portabilityId = computed(() => {
  return route.params.id;
});

const isImpersonateUser = computed(() => {
  return isImpersonate();
});

const isAcceptButtonLoading = computed(() => {
  return isLoading.value || isAcceptingPortability.value;
});

const isAcceptButtonDisabled = computed(() => {
  return (
    hasError.value || isRejectingPortability.value || isImpersonateUser.value
  );
});

const isRejectButtonLoading = computed(() => {
  return isLoading.value || isRejectingPortability.value;
});

const isRejectButtonDisabled = computed(() => {
  return (
    hasError.value || isAcceptingPortability.value || isImpersonateUser.value
  );
});

const showEnableMFAButton = computed(() => {
  return !portability.value?.enabledMFA;
});

const handleAcceptPortabilityRequest = async () => {
  isAcceptingPortability.value = true;
  await updatePortability(PortabilityRequestStatus.accept);
  isAcceptingPortability.value = false;
};

const handleRejectPortabilityRequest = async () => {
  isRejectingPortability.value = true;
  await updatePortability(PortabilityRequestStatus.reject);
  isRejectingPortability.value = false;
};

const updatePortability = async (status: PortabilityRequestStatus) => {
  try {
    const data = await updatePortabilityRequest(status, portabilityId.value);

    portabilityRequestConclusion.value = data;

    emit('on-change-step', PortabilityRequestSteps.Conclusion);
  } catch {
    const action =
      status === PortabilityRequestStatus.accept ? 'aprovar' : 'recusar';

    notify({
      group: 'wrn-notifications',
      text: `Ocorreu um problema ao ${action} a solicitação. Tente novamente.`,
      type: NotificationTypes.error
    });
  }
};

const fetchPortabilityDetails = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;
    const response = await getPortabilityDetails(portabilityId.value);

    portability.value = response;
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const goToMFAPage = () => {
  router.push({
    name: 'security',
    query: {
      module: MFAModules.TRADE
    }
  });
};

onMounted(async () => {
  await fetchPortabilityDetails();
});

return { __sfc: true,isLoading, hasError, isAcceptingPortability, isRejectingPortability, portability, portabilityRequestConclusion, emit, route, router, portabilityId, isImpersonateUser, isAcceptButtonLoading, isAcceptButtonDisabled, isRejectButtonLoading, isRejectButtonDisabled, showEnableMFAButton, handleAcceptPortabilityRequest, handleRejectPortabilityRequest, updatePortability, fetchPortabilityDetails, goToMFAPage, NavBar, HeadingDisplay, HelperViewStatus, ButtonContainer, ButtonPrimary, ButtonSecondary, SkeletonLoader, BackButton, AssetRow, PortabilityDetailsLoader }
}

})